// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KDWk","badges":"styles_badges__wePlP"};